import clsx from "clsx";
import { useEffect, useRef } from "react";
import { IoArrowBackSharp } from "react-icons/io5";
import ExpandIcon from "../../assets/icons/expandIcon.svg";
import { useMapStore } from "../../stores/mapCordinations";
import { BrowseListingView } from "../BrowseListing/browseListingView";
import { BuyerExploreListingsView } from "./buyerExploreListingsView";
import { useShowLoginModalStore } from "../../stores/loginModalStore";
import { useNavigate } from "react-router-dom";

const ExploreListingView = () => {
  const {
    showProperty,
    setShowProperty,
    passListingId,
    fullWidthProperty,
    setFullWidthProperty,
    showSlider,
  } = useMapStore();
  const modalRef = useRef<HTMLDivElement>(null);
  const { showLoginModal } = useShowLoginModalStore();
  const navigate = useNavigate();

  useEffect(() => {
    const handleOutsideClick = (e: MouseEvent) => {
      if (showLoginModal) return;
      if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
        setShowProperty((prev) => !prev);
      }
    };

    if (showProperty) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [showProperty, setShowProperty, showLoginModal]);


  return (
    <div className="relative">
      <BuyerExploreListingsView />
      {showProperty && (
        <div className="fixed z-30 inset-0 w-full bg-[rgba(0,0,0,0.20)] p-20" />
      )}

      <div
        ref={modalRef}
        className={clsx(
          "fixed z-[40] inset-y-0 left-0 h-full bg-white w-full transition-all duration-300 ease-in-out",
          showProperty ? "block" : "hidden",
          fullWidthProperty
            ? "min-w-full max-w-full"
            : "min-w-[1350px] max-w-[85%]",
          showSlider ? "overflow-y-hidden" : "overflow-y-auto"
        )}
      >
        <div className="pt-28 relative w-full">
          <div
            className={clsx(
              "flex items-center justify-between",
              fullWidthProperty ? "container mx-auto w-full" : "px-12"
            )}
          >
            <div className="flex text-z-shark w-full">
              {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
              <div
                className="cursor-pointer flex items-center gap-2 p-1"
                onClick={() => {
                  setShowProperty((prev) => !prev);
                  setFullWidthProperty(false);
                }}
              >
                <IoArrowBackSharp className="text-xl" />
                <span>Back</span>
              </div>
            </div>
            {!fullWidthProperty ? (
              <img
                onClick={() => {
                  navigate(`/listings/${passListingId}`);
                }}
                className="cursor-pointer"
                src={ExpandIcon}
                alt="expand icon"
              />
            ) : (
              <></>
            )}
          </div>
          <BrowseListingView listingId={passListingId} />
        </div>
      </div>
    </div>
  );
};

export { ExploreListingView };
